import Vue from 'vue'
import Router from 'vue-router'
import Index from '../components/Index'
import About from '../components/About'
import Product from '../components/Product'
import Partner from '../components/Partner'
import Connect from '../components/Connect'



Vue.use(Router)

export default new Router({
    routes: [
        {
            path: '/',
            name: 'Index',
            component: Index
        },
        {
            path: '/about',
            name: 'About',
            component: About
        },
        {
            path: '/product',
            name: 'Product',
            component: Product
        },
        {
            path: '/partner',
            name: 'Partner',
            component: Partner
        },
        {
            path: '/connect',
            name: 'Connect',
            component: Connect
        },
    ],
    scrollBehavior() {
        return { x: 0, y: 0 } // 在每次路由切换时总是滚动到顶部
    }

})
